
import React, { useState,useEffect } from "react";
import { useParams,useNavigate } from "react-router-dom";

import loginapi from '../api/login';
import passwordapi from '../api/changePassword';

import { APISERVERURL } from '../APIServerURL';

function ChangePassword({accessToken,setAccessToken,setRefreshFailed,appUserName}) {
  const navigate = useNavigate();
  
  const [oldPassword,setOldPassword]=useState('');
  const [newPassword,setNewPassword]=useState('');
 

  const handleUpdate = async () => {
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await passwordapi.post('/changePassword',{oldPassword,newPassword},{headers:{'Authorization':`Bearer ${accessToken}`}});  
       if(response && response.data && response.data.success)
       {
        alert("Password Changed!");
       }
       else{
        alert(response.data.message);
       }
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await passwordapi.post('/changePassword',{oldPassword,newPassword},{headers:{'Authorization':`Bearer ${nat}`}});   
                      if(response && response.data && response.data.success)
                        {
                         alert("Password Changed!");
                        }else{
                          alert(response.data.message);
                         }
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };


  const handleGoBack = () => {
    navigate(`/gradeEntryCourses`); 
  };
  
    return (
      <main className="w-full">
        <div className="flex flex-col items-center w-full">

          <div className="w-full bg-red-100 relative py-1 mb-2"> 
              {/* Heading */}
              <h1 className="text-2xl  text-gray-400 text-center">CHANGE PPASSWORD</h1>
              <p className="w-full text-center text-xs">{appUserName}</p>     
          </div>

          <div className="bg-blue-100 max-w-[600px] w-[99%] p-5 rounded-lg shadow-md">

          <div className="mb-4">
            <p className="text-xs text-gray-600">OLD PASSWORD</p>
            <input
              className="mt-1 w-full border-b border-gray-400 focus:border-blue-500 outline-none bg-transparent text-gray-700 p-1"              
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            />
            </div>

            <div className="mb-6">
              <p className="text-xs text-gray-600">NEW PASSWORD</p>
              <input
                className="mt-1 w-full border-b border-gray-400 focus:border-blue-500 outline-none bg-transparent text-gray-700 p-1"                
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>


              <div className="w-full flex justify-end">
                <button className="bg-blue-500 text-white text-xs px-3 py-2 rounded-md hover:bg-blue-600 transition-all"
                onClick={handleUpdate} 
                >
                  UPDATE
                </button>
              </div>
            </div>          
        </div>
     
      </main>
    )
  }
  
  export default ChangePassword